import { BoardParticipant } from 'types';

export const isDelegate = (
  memberId: string,
  participants: BoardParticipant[] = []
): boolean => !!participants?.find((participant) => participant.representative === memberId);

export const isRepresentingOtherParticipant = (
  memberId: string,
  participants: BoardParticipant[] = []
): boolean =>
  !!participants?.find(
    (participant) =>
      participant.representative === memberId && participant.member !== memberId
  );
